import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MODAL_TYPE_INQUIRY_TO_CONSULTANT } from '../../../../actions/ModalActions';
import { propArrayShape, propBool, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import Modal from '../../../Ui/Modal';
import ProfessionalInquiryModalForm from './ProfessionalInquiryModalForm';
const ProfessionalInquiryModal = (props) => {
    const { contactForProfessionalQuestionTypes, initialValues, onClickHide, onSubmit, profile, tabViewIsComplete, } = props;
    return (_jsx(Modal, Object.assign({ isWide: true, modalClassName: 'professional-inquiry-modal', modalType: MODAL_TYPE_INQUIRY_TO_CONSULTANT, showCloseButton: false }, { children: _jsx(ProfessionalInquiryModalForm, { contactForProfessionalQuestionTypes: contactForProfessionalQuestionTypes, initialValues: initialValues, onClickHide: onClickHide, onSubmit: onSubmit, profile: profile, tabViewIsComplete: tabViewIsComplete }) })));
};
ProfessionalInquiryModal.propTypes = {
    contactForProfessionalQuestionTypes: propArrayShape().isRequired,
    initialValues: propShape().isRequired,
    onClickHide: propFunc().isRequired,
    onSubmit: propFunc().isRequired,
    profile: propShape().isRequired,
    tabViewIsComplete: propBool().isRequired,
};
export default ProfessionalInquiryModal;
